import { render, staticRenderFns } from "./PageHeaderHelpList.vue?vue&type=template&id=143c6314&"
import script from "./PageHeaderHelpList.vue?vue&type=script&lang=js&"
export * from "./PageHeaderHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports